var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-xl g-0 g-lg-2", class: [_vm.containerClass] },
    [
      _c(
        "div",
        {
          staticClass: "row h-100 g-0 header-small",
          staticStyle: {
            "background-image": "url('/images/temp/head-pr.png')",
          },
        },
        [
          _c("div", { staticClass: "col d-flex align-items-end" }, [
            _vm.title
              ? _c(
                  "h1",
                  {
                    staticClass: "mb-4 mx-4 mx-lg-0 mt-4",
                    class: [_vm.classProp],
                  },
                  [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.isLoggedIn
            ? _c("div", { staticClass: "col-12 col-lg-5 col-md-6" }, [
                _vm._m(0),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isLoggedIn
            ? _c(
                "div",
                { staticClass: "col-12 col-lg-5 col-md-6 ic-form main-form" },
                [_vm._m(1)]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "info-box d-flex justify-content-lg-end flex-column ms-auto mt-5",
      },
      [
        _c("h2", { staticClass: "h3" }, [
          _vm._v("\n          Ważne informacje dla pasażerów\n        "),
        ]),
        _vm._v(" "),
        _c("ul", {}, [
          _c("li", [
            _c("i", { staticClass: "bi bi-info-circle" }),
            _vm._v(" Aktualność dostępność pociągów PKP Intercity"),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("i", { staticClass: "bi bi-info-circle" }),
            _vm._v(
              " Limit 50 proc. miejsc siedzących w pociągach PKP Intercity"
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c("i", { staticClass: "bi bi-info-circle" }),
            _vm._v(
              " Informacja dla podróżujących w relacjach międzynarodowych"
            ),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", {}, [
      _c("form", {}, [
        _c("h2", { staticClass: "h3" }, [
          _vm._v("\n            Logowanie do panelu dziennikarza\n          "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "small" }, [
          _vm._v(
            "\n            Zalogowanie do panelu daje możliwość skorzystania ze zdjęć,\n            materiałów wideo, a także materiałów graficznych i logotypów spółki,\n          "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "w-75 mx-auto" }, [
          _c("div", { staticClass: "mb-2 input-group icon icon__person" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Login",
                "aria-label": "Login",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-2 input-group icon icon__key" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: {
                type: "password",
                placeholder: "Hasło",
                "aria-label": "Hasło",
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-warning mb-2 w-100",
              attrs: { type: "submit" },
            },
            [_vm._v("Zaloguj")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }